import { makeAutoObservable } from 'mobx'
import { createContext } from 'react'
import { ConnectionStatus, StateSyncStatus, SyncStatus } from 'screens/ProseEdit/components/RealtimeProvider/utils'

export const CollabStateContext = createContext<CollabState | null>(null)

export class CollabState {
  connStatus: ConnectionStatus = ConnectionStatus.Connecting
  saveStatus: StateSyncStatus = StateSyncStatus.UpToDate
  syncStatus: SyncStatus = SyncStatus.InitialSync

  constructor() {
    makeAutoObservable(this)
  }

  get statusMessage() {
    if (this.connStatus === ConnectionStatus.LongConnecting && this.saveStatus === StateSyncStatus.Behind) {
      return 'The document is locked until saving is completed.'
    } else if (this.connStatus === ConnectionStatus.LongConnecting) {
      return 'The document is locked until network connection is restored.'
    }

    return ''
  }

  setSaveStatus(status: StateSyncStatus) {
    if (this.saveStatus === status) return

    const prevStatus = this.saveStatus
    this.saveStatus = status

    if ([status, prevStatus].includes(StateSyncStatus.Behind)) {
      // eslint-disable-next-line no-console
      console.debug(`[conn] RealTime Save ${StateSyncStatus[status]}`)
    }
  }

  setSyncStatus(status: SyncStatus) {
    this.syncStatus = status
    // eslint-disable-next-line no-console
    console.debug(`[conn] RealTime Sync ${SyncStatus[status]}`)
  }

  setConnStatus(status: ConnectionStatus) {
    this.connStatus = status
    // eslint-disable-next-line no-console
    console.debug(`[conn] RealTime ${ConnectionStatus[status]}`)
  }
}
